import eav from '@/components/tools/eav'

export default {
  setCustomerWithWrapper (state, data) {
    state.customer = data?.customer
    state.customerAddress = data?.customerAddress
    state.merchant = data?.merchant
    state.merchantAddress = data?.merchantAddress
    state.profileType = data?.submittedProfileDataType
    state.hasCompletedProfileData = data?.hasCompletedProfileData
    state.hasAnyAds = data?.hasAnyAds
    state.needAvailabilityConfirmation = data?.needAvailabilityConfirmation
    state.isEditing = data?.editing
  },

  setCustomer (state, data) {
    state.customer = data
  },

  setHasCustomerAnySearches (state, data) {
    state.hasAnySearches = data
  },

  setHasCustomerAnyActiveSearches (state, data) {
    state.hasAnyActiveSearches = data
  },

  setSavedSearches (state, data) {
    state.savedSearches = data.searches
    state.savedSearchesPages = data.pages
  },

  setSavedSearchName (state, {
    id,
    name
  }) {
    state.savedSearches.find(s => s.id === id)
      .name = name
  },

  setSavedSearchesPage (state, page) {
    state.savedSearchesPage = page
  },

  setSavedSearchesOrderBy (state, value) {
    state.savedSearchesOrderBy = value
  },
  setSavedSearchesOrderDir (state, value) {
    state.savedSearchesOrderDir = value
  },

  sanitizeEmail (state) {
    if (state.customer.email) {
      state.customer.email = state.customer.email?.trim()?.toLowerCase()
    }
  },

  setCustomerSegmentation (state, data) {
    state.customer.segmentation = data
  },

  setMerchant (state, data) {
    state.merchant = data
  },

  setCustomerAddress (state, address) {
    state.customerAddress = address
  },

  setMerchantAddress (state, address) {
    state.merchantAddress = address
  },

  setAdsInEditing (state, data) {
    state.adsInEditing = data.products
    if (data.products?.length > 0) {
      state.isEditing = true
    } else {
      state.isEditing = false
    }
  },

  setAdsInUnderReview (state, data) {
    state.adsInUnderReview = data.products
  },

  setAds (state, data) {
    state.adsProducts = data.products
    state.adsPages = data.pages
  },
  setAdsPage (state, page) {
    state.adsPage = page
  },

  setProfileType (state, data) {
    state.profileType = data
  },

  setPurchases (state, data) {
    state.purchasesProducts = data.products
    state.purchasesPages = data.pages
    state.purchasesFilters = data.filters
  },

  setPurchasesPage (state, page) {
    state.purchasesPage = page
  },

  setWatchlist (state, data) {
    state.watchlistProducts = data.products
    state.watchlistPages = data.pages
    state.watchlistFilters = data.filters
    state.watchlistRefreshKey++
  },

  setWatchlistPage (state, page) {
    state.watchlistPage = page
  },

  setCustomerAttributes (state, attributes) {
    state.customerAttributes = attributes
  },

  setCustomerAddressAttributes (state, attributes) {
    state.customerAddressAttributes = attributes
  },

  setMerchantAttributes (state, attributes) {
    state.merchantAttributes = attributes
  },

  setMerchantAddressAttributes (state, attributes) {
    state.merchantAddressAttributes = attributes
  },

  setSimpleCustomerAttribute (state, {
    key,
    value
  }) {
    state.customer[key] = value
  },

  unsetSimpleCustomerAttribute (state,
    key) {
    state.customer[key] = null
  },

  setCustomerAttribute (state, {
    attributeCode,
    value
  }) {
    eav.setEavAttribute(attributeCode, value, state.customer.attributes, state.customerAttributes)
  },

  setMerchantAttribute (state, {
    attributeCode,
    value
  }) {
    eav.setEavAttribute(attributeCode, value, state.merchant.attributes, state.merchantAttributes)
  },

  setCustomerAddressAttribute (state, {
    attributeCode,
    value
  }) {
    eav.setEavAttribute(attributeCode, value, state.customerAddress.attributes, state.customerAddressAttributes)
  },

  setMerchantAddressAttribute (state, {
    attributeCode,
    value
  }) {
    eav.setEavAttribute(attributeCode, value, state.merchantAddress.attributes, state.merchantAddressAttributes)
  },

  setEmailAutomations (state, data) {
    state.emailAutomations = data
  },

  setShowLowerTargetPriceForm (state, value) {
    state.showLowerTargetPriceForm = value
  }

}
